import { Injectable } from "@angular/core";
import { StateService } from "@core-services/state.service";
import { Observable } from "rxjs";
import { PaymentOption } from "../entities/payment-option.model";

interface State {
	paymentOptions: PaymentOption[];
}

const initialState: State = {
	paymentOptions: []
};

@Injectable({
	providedIn: "any"
})
export class PaymentOptionsStateService extends StateService<State> {
	// TODO: current "bugfixer" (transferred from masterDataService + reverse dependency) - to be solved in a "civilized way"
	private isCacheInvalid: boolean = false;

	public constructor() {
		super(initialState);
	}

	public getPaymentOptions$(): Observable<PaymentOption[]> {
		return this.select((state) => state.paymentOptions);
	}

	public updatePaymentOptions(options: PaymentOption[]): void {
		this.isCacheInvalid = false;
		this.setState({ paymentOptions: options });
	}

	public isPaymentOptionsLoaded(): boolean {
		return this.state.paymentOptions.length !== 0 && !this.isCacheInvalid;
	}

	public markPaymentOptionsAsOutdated(): void {
		this.isCacheInvalid = true;
	}
}
